import React from 'react';
import { AlertTriangle, Info, X } from 'lucide-react';

const ConfirmModal = ({
    isOpen,
    title,
    message,
    onConfirm,
    onCancel,
    confirmLabel = "Confirm",
    cancelLabel = "Cancel",
    variant = "danger", // danger | info
    isLoading = false
}) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[999] flex items-center justify-center p-4 sm:p-6">
            {/* Backdrop */}
            <div
                className="absolute inset-0 bg-slate-900/60 backdrop-blur-sm animate-fade-in"
                onClick={onCancel}
            />

            {/* Modal Card */}
            <div className="relative w-full max-w-md bg-white rounded-3xl shadow-2xl border border-slate-200 overflow-hidden animate-scale-up">
                <div className="p-8">
                    <div className="flex items-start justify-between mb-6">
                        <div className={`w-14 h-14 rounded-2xl flex items-center justify-center shrink-0 ${variant === 'danger' ? 'bg-rose-50 text-rose-500' : 'bg-blue-50 text-blue-500'
                            }`}>
                            {variant === 'danger' ? <AlertTriangle className="w-8 h-8" /> : <Info className="w-8 h-8" />}
                        </div>
                        <button
                            onClick={onCancel}
                            className="p-2 hover:bg-slate-100 rounded-xl transition-colors text-slate-400"
                        >
                            <X className="w-6 h-6" />
                        </button>
                    </div>

                    <h3 className="text-2xl font-bold text-slate-800 font-montserrat mb-3 tracking-tight">
                        {title}
                    </h3>
                    <p className="text-slate-500 font-inter leading-relaxed">
                        {message}
                    </p>
                </div>

                <div className="flex flex-col-reverse sm:flex-row gap-3 p-8 pt-0">
                    <button
                        onClick={onCancel}
                        className="flex-1 px-6 py-4 bg-slate-50 text-slate-600 font-bold rounded-2xl hover:bg-slate-100 transition-all font-montserrat uppercase text-[13px] tracking-wider"
                    >
                        {cancelLabel}
                    </button>
                    <button
                        onClick={onConfirm}
                        disabled={isLoading}
                        className={`flex-1 px-6 py-4 text-white font-bold rounded-2xl transition-all shadow-lg font-montserrat uppercase text-[13px] tracking-wider flex items-center justify-center gap-2 ${variant === 'danger'
                                ? 'bg-rose-500 hover:bg-rose-600 shadow-rose-200'
                                : 'bg-blue-500 hover:bg-blue-700 shadow-blue-200'
                            } ${isLoading ? 'opacity-70 cursor-not-allowed text-white/80' : ''}`}
                    >
                        {isLoading ? (
                            <>
                                <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
                                <span>Processing...</span>
                            </>
                        ) : (
                            confirmLabel
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmModal;
